<div class="monaco-editor-container">
  <ngx-monaco-editor [options]="editorOptions" [(ngModel)]="code" (ngModelChange)="onCodeChange($event)"
    [style.height.px]="editorHeight">
  </ngx-monaco-editor>
</div>